var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 4.5C8.25 5.74264 7.24264 6.75 6 6.75C4.75736 6.75 3.75 5.74264 3.75 4.5C3.75 3.25736 4.75736 2.25 6 2.25C7.24264 2.25 8.25 3.25736 8.25 4.5ZM7.125 4.5C7.125 5.12132 6.62132 5.625 6 5.625C5.37868 5.625 4.875 5.12132 4.875 4.5C4.875 3.87868 5.37868 3.375 6 3.375C6.62132 3.375 7.125 3.87868 7.125 4.5Z",
    fill: "#696969"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.09842 10.7441C6.98026 10.8761 6.86253 11.0076 6.74587 11.1388C6.48973 11.4269 6.23878 11.7135 6 12C5.76122 11.7135 5.51027 11.4269 5.25413 11.1388C5.13751 11.0077 5.0198 10.8762 4.90168 10.7442C3.24218 8.89025 1.5 6.94394 1.5 4.5C1.5 1.5 3.75 0 6 0C8.25 0 10.5 1.5 10.5 4.5C10.5 6.94394 8.75792 8.89015 7.09842 10.7441ZM9.375 4.5C9.375 5.6561 8.87299 6.73418 8.04481 7.86748C7.63241 8.43182 7.15786 8.98503 6.65283 9.5539C6.52811 9.69439 6.4004 9.83706 6.27136 9.98122C6.18147 10.0816 6.09061 10.1831 6 10.2848C5.90928 10.183 5.81864 10.0818 5.72864 9.98122C5.5996 9.83706 5.47189 9.69439 5.34717 9.5539C4.84214 8.98503 4.36759 8.43182 3.95519 7.86748C3.12701 6.73418 2.625 5.6561 2.625 4.5C2.625 3.30528 3.06184 2.4919 3.65366 1.96584C4.26619 1.42137 5.1147 1.125 6 1.125C6.8853 1.125 7.73381 1.42137 8.34634 1.96584C8.93816 2.4919 9.375 3.30528 9.375 4.5Z",
    fill: "#696969"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.902a667a7e57cff4dd67b1cfd7c46acd.svg";
export { ForwardRef as ReactComponent };